export const coreConstantsService = () => {
  // Composables
  const { getStorageUnitlPromise } = useAsyncCacheData();

  // Repositories
  const { getConstantes } = coreConstanteRepository();

  // Stores
  const { setConstants } = useCoreStore();

  // Actions
  const loadConstantes = async () => {
    await getStorageUnitlPromise({
      key: 'core-constantes',
      getData: getConstantes,
      setData: setConstants,
    });
  };

  return {
    loadConstantes,
  };
};
